import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDatePipe',
    standalone: false
})
export class FormatDate implements PipeTransform {
    constructor() {

    }
    transform(date: any): Date {
        // Check if the date is null or undefined
        if (!date) {
            return null; // Return null
        }

        if (date.indexOf('/') === -1) {
            return date;
        }
        const newDateISO = date.split("/");
        const convertedDate = `${newDateISO[1]}/${newDateISO[0]}/${newDateISO[2]}`;
        return new Date(convertedDate);
    }
}